import { render } from "./PharmacyCashPayments.vue?vue&type=template&id=d2a16024&scoped=true"
import script from "./PharmacyCashPayments.vue?vue&type=script&lang=js"
export * from "./PharmacyCashPayments.vue?vue&type=script&lang=js"

import "./PharmacyCashPayments.vue?vue&type=style&index=0&id=d2a16024&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a16024"]])

export default __exports__